import { Card, CardBody, Col, Label } from "reactstrap";
import CommonToggleHeader from "../Common/CommonToggleHeader";
import { UserInformations } from "../../../../Constant";
import { UserInformationTable } from "./UserInformationTable";

const UserInformation = () => {
  return (
    <Col xxl="6" xl="7" sm="12" className="box-col-8">
      <Card>
        <CommonToggleHeader title={UserInformations} />
        <CardBody className="pt-0 userinformation">
          <div className="table-responsive theme-scrollbar">
            <div id="transaction_wrapper" className="dataTables_wrapper no-footer">
              <div id="transaction_filter" className="dataTables_filter">
                <Label>Search:<input type="search"/></Label>
              </div>
              <UserInformationTable />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default UserInformation;
